import React from "react";
import Content from "../components/Content";
import Problems from "../components/Problems";

const Home = () => {
  return (
    <>
      <Content />
      <Problems />
    </>
  );
};

export default Home;
